import component from './HorizontalLayout';

export default component;
